import CommonRadio from './CommonRadio'

export default CommonRadio
